<template>
  <div>
    <div class="content-container">
      <h3>Join by game code</h3>
      <div class="form-row">
        <div class="form-group col-md-6 col-sm-12">
          <input
            type="text"
            class="form-control"
            placeholder="Username"
            v-model="username"
          />
        </div>
        <div class="form-group col-md-6 col-sm-12">
          <input
            type="text"
            class="form-control"
            placeholder="Game Code or Choose from Below"
            v-model="gameCode"
          />
        </div>
      </div>
      <button
        class="btn btn-success mr-1"
        v-bind:disabled="username == '' || gameCode == ''"
        v-on:click="enterGame(gameCode)"
      >
        <i class="fas fa-play mr-3"></i>Join Game
      </button>
      <button
        class="btn btn-primary"
        title="Spiele nachladen"
        v-on:click="reload()"
      >
        <i class="fas fa-sync-alt mr-3"></i>Refresh
      </button>
      <div class="alert alert-danger mt-3" v-if="error">{{ error }}</div>

      <div v-if="runningGames > 0">
        <h3 class="mt-5">Choose from existing games</h3>
        <div class="game-list row">
          <div
            class="col-sm-6 col-md-4"
            v-for="game in games"
            v-if="game.public && game.state === 0"
            v-bind:key="game.id"
          >
            <div class="card game-entry my-2">
              <div class="card-header">{{ game.gameCode }}</div>
              <div class="card-body">
                <h6
                  class="card-subtitle mb-2 text-muted"
                  v-if="!game.playerIDs.length"
                >
                  <b>Admin:</b> Computer
                </h6>
                <p class="card-text">
                  <b>Game:</b> [{{ game.playerIDs.length }}/{{
                    game.maxPlayers
                  }}]<br /><b>min. number of players:</b> {{ game.minPlayers
                  }}<br />
                  <b>Number of questions:</b> {{ game.qnum }}<br />
                  <b>Status: </b> {{ getStatus(game) }}
                </p>
                <button
                  title="Join the game"
                  v-bind:disabled="username == '' || game.state !== 0"
                  v-on:click="enterGame(game.gameCode)"
                  v-bind:class="{
                    'btn-success': game.state === 0,
                    'btn-secondary': game.state === 1,
                    'btn-danger': game.state === 2,
                  }"
                  class="btn"
                >
                  <i class="fas fa-play"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlayerService from "@/services/PlayerService.js";
import GameService from "@/services/GameService.js";

export default {
  name: "EnterGame",
  data() {
    return {
      gameCode: "",
      username: "",
      error: "",
      games: [],
      runningGames: 0,
    };
  },
  created() {
    this.getGames();
  },
  methods: {
    async getGames() {
      this.games = await GameService.getGames();
      this.runningGames = this.games.filter(
        (game) => game.public && game.state === 0
      ).length;
    },
    getStatus(game) {
      switch (game.state) {
        case 0:
          return "Wait...";
        case 1:
          return "Battle is underway";
        case 2:
          return "Completed";
      }
    },
    async reload() {
      this.getGames();
    },
    async enterGame(gameCode) {
      // validate username
      if (!PlayerService.validateUsername(this.username)) {
        this.error =
          "The username may only consist of numbers, uppercase letters and lowercase letters and must be between three and 16 characters long.";
        return;
      }

      let game;

      // check if gameCode exists
      try {
        game = await GameService.getGame(gameCode).then();
      } catch (err) {
        this.error = err.response.data.error;
        return;
      }

      // if game is full
      if (game.playerIDs.length >= game.maxPlayers) {
        this.error = "The maximum number of players has already been reached.";
        return;
      }

      // create user, add to game and redirect
      try {
        const player = await PlayerService.createPlayer(this.username);
        this.$store.dispatch("setPlayer", player);

        this.$router.push("/match/" + gameCode + "/waiting");
      } catch (err) {
        this.error = err.response.data.error;
      }
    },
  },
};
</script>
